<template>
  <div>
    <div
      class="flex flex-col md:flex-row justify-between items-start md:items-center md:mb-2"
    >
      <div class="mb-4 md:mb-0">
        <div class="sm:mb-4 sm:mt-0 mb-4 mt-2">
          <span class="inline-flex bg-custom_black2 text-white text-sm font-semibold rounded-md px-3 py-1">
            {{ props.property.property_type }}
          </span>
          <span 
            class="inline-flex bg-tuin_hover text-white text-sm font-semibold rounded-md px-3 py-1 ml-2"
          >
            {{ props.property.property_movement}}
          </span>
        </div>
        <p class="text-gray-400 text-sm">
          <span class="flex flex-col lg:flex-row lg:items-center">
            <span class="flex items-center mr-4">
              <span class="text-custom_gray font-normal mr-2">ID de la propiedad:</span> 
              <span class="text-black font-medium">{{ props.property.property_code }}</span> 
            </span>

            <span class="flex items-center mt-1 lg:mt-0">
              <span class="text-custom_gray font-normal mr-2">Fecha de publicación:</span>
              <span class="text-black font-medium">{{ props.property.fecha_creation }}</span>
            </span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>


<script setup>
  
  const props = defineProps({
    property: {
      type: Object,
      required: true,
      default: () => ({ property_name: '' })
    }
  });

  
</script>
